import { Component, OnInit, ViewChild } from '@angular/core';
import { _currencyFormat } from 'app/utils/trip2-query-builder/utils/helpers';
import { GridOptions } from 'ag-grid';
import { BooleanCheckComponent } from 'app/pages/A2-utils/grid-components/boolean-check/boolean-check.component';
import { UsersService } from 'app/pages/users/users.service';
import { ProvidersBillingService } from '../providers-billing-service.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { T2CardComponent } from '../../../trip2-theme/components/t2-card/t2-card.component';
import * as moment from 'moment';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-denials',
  templateUrl: './denials.component.html',
  styleUrls: ['./denials.component.scss']
})
export class DenialsComponent implements OnInit {

  providers: any[];
  selectedProvider;
  enableClearFilter = false;
  enableClearSort = false;
  dateDenials: any;
  currentDate: any;
  activeDeadline: boolean;
  countGridTrips = 0;
  private daysAllowed = 90; // dias permitidos para poder apelar trips denegados

  protected grid = <GridOptions> {};

  private tripId: any; // Id Trip Selected
  protected tabs = 1; // Var Tabs Appeal Claim

  /**
   * @description Reservation module - component
   */
  protected isOpenedRider = false;
  protected visibleReservation = false;
  protected selectedTripData: any;

  @ViewChild('driverManifest') private driverManifest: T2CardComponent;

  constructor(
    private userService: UsersService,
    private pBillingService: ProvidersBillingService,
    private loadingMask: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    this.grid.columnDefs = this.getColumns();
    this.grid.onFilterChanged = (params) => {
      this.enableClearFilter = params.api['filterManager'].advancedFilterPresent;
    };
    this.grid.onSortChanged = () => {
      this.enableClearSort = this.grid.api.getSortModel().length !== 0;
    };
  }

  ngOnInit() {
    this.getProviders();
    this.getCurrentDate();
  }

  /**
   * this get all providers
   */
  private getProviders() {
    this.userService.getProvidersForUser().subscribe(
      data => {
        this.providers = data;
        if (data.length === 1) {
          this.selectedProvider = data[0].companyid;
        }
      }
    );
  }

  /**
   * this retrieve data form server
   */
  private retrieveData() {
    if (this.selectedProvider) {
      this.loadingMask.show();
      this.pBillingService.getPaymentDenied(this.selectedProvider).finally(
        () => {
          this.loadingMask.hiden();
        }
      ).subscribe(
        data => {
          data.forEach(
            row => {
              if (row.dateofserviceformatted) {
                this.getDateLimit(row.dateofserviceformatted);
                this.compareDates(row.dateofserviceformatted, this.currentDate);
                if (this.activeDeadline && row.definitivedenial === false) {
                  row.definitivedenial = this.activeDeadline;
                }
                return row.dateDenials = this.dateDenials;
              }
            }
          );
          if (this.grid.api) {
            this.grid.api.setRowData(data);
            this.countGridTrips = data.length;
          }
        }
      );
    }
  }

  /**
   * this exevute when user change provider
   */
  onChangeProvider() {
    this.retrieveData();
  }

  /**
   * this clear filter
   */
  clearFilters() {
    this.grid.api.setFilterModel(null);
  }

  /**
   * this clear sort
   */
  clearSort() {
    this.grid.api.setSortModel(null);
  }
  /**
   * this execute when grid is ready
   * @param grid
   */
  onGridReady(grid) {
    grid.api.sizeColumnsToFit();
    grid.api.setRowData([]);
  }

  /**
   * @NAME getDateLimit
   * @DESCRIPTION Aumenta la fecha en 60 dias, la pasa a la Variable.
   */
  getDateLimit(date) {
    this.dateDenials = moment(date)
      .add(80, 'days')
      .format('YYYY-MM-DD');
  }

  /**
   * @NAME getCurrentDate
   * @DESCRIPTION Trae la fecha actual y la pasa a la variable.
   */
  getCurrentDate() {
    this.currentDate = moment().format('YYYY-MM-DD');
  }

  /**
   * @NAME compareDates
   * @DESCRIPTION Compara las fecha si pasaron 90 dias.
   */
  compareDates(one, tow) {
    const dateOne = moment(one);
    const dateTow = moment(tow);
    const difDate = dateTow.diff(dateOne, 'days');
    if (difDate > this.daysAllowed) {
      this.activeDeadline = true;
    } else { this.activeDeadline = false; }
  }

  private getColumns() {
    return [
      {
        colId: 'init',
        width: 20
      },
      {
        headerName: 'Appeal',
        field: 'Appeal',
        colId: 'Appeal',
        cellRenderer: (params) => {
          if (params.data.definitivedenial === false) {
            return '<i class="fa fa-telegram fa-lg color-primary"></i>';
          } else {
            return '<i class="fa fa-ban fa-lg color-danger"></i>';
          }
        },
        width: 80
      },
      {
        headerName: 'DOS',
        field: 'dateofserviceformatted',
        colId: 'dateofserviceformatted',
        width: 150
      },
      {
        headerName: 'Denial Reason',
        field: 'paymentdeniedreason',
        colId: 'paymentdeniedreason',
        width: 150
      },
      // {
      //   headerName: 'Deadline',
      //   field: 'dateDenials',
      //   colId: 'dateDenials',
      //   width: 150,
      //   /*cellRenderer: (params) => {
      //     let ico = '';
      //     if (params.data.errorValid === true) {
      //       ico = 'fa-check color-success';
      //     }
      //     if (params.data.errorValid === false) {
      //       ico = 'fa-exclamation color-danger';
      //     }
      //     return `<i class="fa ${ico}" aria-hidden="true"></i>`;
      //   }*/
      // },
      {
        headerName: 'Manifest',
        field: 'tripmanifest',
        colId: 'tripmanifest',
        width: 100,
        cellRendererFramework: BooleanCheckComponent
      },
      {
        headerName: 'Reservation',
        field: 'consecutive',
        colId: 'reservation',
        width: 100
      },
      {
        headerName: 'Trip Status',
        field: 'tripstatus',
        colId: 'tripstatus',
        width: 100
      },
      {
        headerName: 'Payment Status',
        field: 'paymentstatus',
        colId: 'PaymentStatus',
        width: 100
      },
      {
        headerName: 'Patient Name',
        field: 'ridername',
        colId: 'patientname'
      },
      {
        headerName: 'Apt Time',
        field: 'appointmenttime',
        colId: 'appointmenttime'
      },
      {
        headerName: 'Sch. PU Time',
        field: 'pickup',
        colId: 'putime',
        width: 100
      },
      {
        headerName: 'Act. PU Time',
        field: 'actualpickupformatted',
        colId: 'actualpickup',
        width: 100
      },
      {
        headerName: 'Pickup',
        field: 'pickupaddress',
        colId: 'pickup',
        width: 300
      },
      {
        headerName: 'Act. DO Time',
        field: 'actualdropoffformatted',
        colId: 'dropofftime',
        width: 100
      },
      {
        headerName: 'Destination',
        field: 'dropoffaddress',
        colId: 'destination',
        width: 300
      },
      {
        headerName: 'Leg',
        field: 'leg',
        colId: 'leg',
        width: 100
      },
      {
        headerName: 'Driver Name',
        field: 'drivername',
        colId: 'drivername',
        width: 200
      },
      {
        headerName: 'Veh. Number',
        field: 'vehiclecode',
        colId: 'vehiclenumber',
        width: 100
      },
      {
        headerName: 'Signature',
        field: 'tripreasonsign',
        colId: 'signature'
      },
      {
        headerName: 'Amnt Paid Prov.',
        field: 'provideramount',
        colId: 'amount',
        width: 100,
        cellRenderer: (params) => {
          return params.value ? '$' + params.value : '';
        }
      }
    ];
  }

  /**
   * @description Event Clicked to grid
   * @param event
   */
  cellClicked(event) {
    if (event.colDef.colId === 'Appeal') {
      if (event.data.definitivedenial === false) {
        this.driverManifest.open();
        this.tripId = event.data.tripid;
      } else {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Warning',
          text: 'Appeal is not Allow',
          type: 'warning',
        });
      }

    }
  }

  /**
   * @description Event Appeal component
   * @param event
   */
  eventAppeal(event) {
    this.onChangeProvider();
    this.driverManifest.close();
  }

  /**
   * @description Open Reservation Event
   * @param event
   */
  openReservation(event) {
    this.selectedTripData = event.data;
    this.tripId = event.data.tripid;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/providers-billing/denials/denials.component.ts